// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("data:image/svg+xml;utf8,<svg fill=%27black%27 height=%2724%27 viewBox=%270 0 24 24%27 width=%2724%27 xmlns=%27http://www.w3.org/2000/svg%27><path d=%27M7 10l5 5 5-5z%27/></svg>", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.left-bar {
  width: 25%;
  /* Changed from 20% to 25% */
  height: 100%;
  background-color: white;
  display: flex;
  flex-direction: column;
  flex: 1 1;
  border: 1px solid black;
}

.left-bar__outputs,
.left-bar__settings {
  flex: 1 1;
  height: 42%;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: flex-start;
}

.left-bar__outputs {
  border-bottom: 1px solid black;
}

.left-bar__title-area {
  background-color: rgb(131, 191, 131);
  width: 100%;
}

/* Grey background area around the product selection */
.left-bar__product-wrapper {
    width: 100%;
    background-color: #f0f0f0; /* Light grey background */
    padding: 10px 0; /* Vertical padding to make it stand out */
    display: flex;
    justify-content: center; /* Optional: centers the dropdown */
}

.left-bar__product-area {
    width: 90%; /* Optional: makes the select not fully stretched if you want some margin */
}


.left-bar__season-area {
  border: 1px solid black;
  border-left: 0px;
  border-right: 0rem;
  background-color: white;
  width: 100%;
}

.left-bar__title {
  margin-left: 1rem;
}

.left-bar__subtitle {
  margin-left: 1rem;
}

.left-bar__subtitle {
  margin-left: 1rem;
  margin-top: 0.5rem;
  margin-bottom: 0.5rem;
}

.left-bar__text {
  font-size: 16px;
  color: black;
  margin-left: 1rem;
}

.left-bar__options-area {
  display: flex;
  flex-direction: column;
  margin-top: 0.5rem;
}

.left-bar__temperature-select {
  margin-top: 0.5rem;
  margin-left: 1rem;
}

.left-bar__temperature-select select {
  padding: 0.3rem;
  /* Increases the padding for a larger clickable area */
  border-radius: 4px;
  /* Optional: rounded corners */
}

.left-bar__radio-options-area {
  padding-top: 1rem;
}

.left-bar__temperature-select .dropdown-row {
  display: flex;
  justify-content: space-between;
  /* Spread label and dropdown */
  align-items: center;
  /* Align items vertically */
  margin-bottom: 1rem;
  /* Add spacing between rows */
}

.left-bar__temperature-select label {
  flex: 1 1;
  /* Allow label to take up remaining space */
  text-align: left;
  /* Keep label text aligned to the left */
  margin-right: 2rem;
  /* Increase spacing between label and dropdown */
}

.left-bar__temperature-select select {
  flex: 0 1;
  /* Keep dropdown size fixed */
  width: auto;
  /* Let dropdown size itself naturally */
  margin-left: auto;
  /* Push dropdowns to the far right */
}

/* Select s veľkou šipkou (iba pre produkt a veličinu) */
.left-bar__dropdown--large-arrow {
    width: 100%;
    font-size: 1rem;
    padding: 8px 40px 8px 10px;
    border: 1px solid black;
    border-radius: 4px;
    cursor: pointer;
    background-color: white;

    /* Vlastná veľká šipka */
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
    background-repeat: no-repeat;
    background-position: right 5px center;
    background-size: 30px 30px; /* Jemne väčšia šipka (nebude presahovať) */
    appearance: none;
    -moz-appearance: none;
    -webkit-appearance: none;
}

/* Selecty so štandardnou šipkou (pre roky a zvyšné nastavenia) */
.left-bar__dropdown {
    width: auto;
    font-size: 1rem;
    padding: 0.3rem;
    border: 1px solid black;
    border-radius: 4px;
    cursor: pointer;
    background-color: white;
}

.velicina-option {
  display: flex;
  align-items: center;
  margin-bottom: 0.5rem;
}

.velicina-option label {
  margin-right: 0.5rem;
}`, "",{"version":3,"sources":["webpack://./src/left_bar.css"],"names":[],"mappings":"AAAA;EACE,UAAU;EACV,4BAA4B;EAC5B,YAAY;EACZ,uBAAuB;EACvB,aAAa;EACb,sBAAsB;EACtB,SAAO;EACP,uBAAuB;AACzB;;AAEA;;EAEE,SAAO;EACP,WAAW;EACX,aAAa;EACb,sBAAsB;EACtB,2BAA2B;EAC3B,uBAAuB;AACzB;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,oCAAoC;EACpC,WAAW;AACb;;AAEA,sDAAsD;AACtD;IACI,WAAW;IACX,yBAAyB,EAAE,0BAA0B;IACrD,eAAe,EAAE,0CAA0C;IAC3D,aAAa;IACb,uBAAuB,EAAE,mCAAmC;AAChE;;AAEA;IACI,UAAU,EAAE,2EAA2E;AAC3F;;;AAGA;EACE,uBAAuB;EACvB,gBAAgB;EAChB,kBAAkB;EAClB,uBAAuB;EACvB,WAAW;AACb;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;EAClB,qBAAqB;AACvB;;AAEA;EACE,eAAe;EACf,YAAY;EACZ,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,sDAAsD;EACtD,kBAAkB;EAClB,8BAA8B;AAChC;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,8BAA8B;EAC9B,mBAAmB;EACnB,2BAA2B;EAC3B,mBAAmB;EACnB,6BAA6B;AAC/B;;AAEA;EACE,SAAO;EACP,2CAA2C;EAC3C,gBAAgB;EAChB,wCAAwC;EACxC,kBAAkB;EAClB,gDAAgD;AAClD;;AAEA;EACE,SAAO;EACP,6BAA6B;EAC7B,WAAW;EACX,uCAAuC;EACvC,iBAAiB;EACjB,oCAAoC;AACtC;;AAEA,wDAAwD;AACxD;IACI,WAAW;IACX,eAAe;IACf,0BAA0B;IAC1B,uBAAuB;IACvB,kBAAkB;IAClB,eAAe;IACf,uBAAuB;;IAEvB,wBAAwB;IACxB,yDAAiL;IACjL,4BAA4B;IAC5B,qCAAqC;IACrC,0BAA0B,EAAE,2CAA2C;IACvE,gBAAgB;IAChB,qBAAqB;IACrB,wBAAwB;AAC5B;;AAEA,iEAAiE;AACjE;IACI,WAAW;IACX,eAAe;IACf,eAAe;IACf,uBAAuB;IACvB,kBAAkB;IAClB,eAAe;IACf,uBAAuB;AAC3B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,oBAAoB;AACtB","sourcesContent":[".left-bar {\n  width: 25%;\n  /* Changed from 20% to 25% */\n  height: 100%;\n  background-color: white;\n  display: flex;\n  flex-direction: column;\n  flex: 1;\n  border: 1px solid black;\n}\n\n.left-bar__outputs,\n.left-bar__settings {\n  flex: 1;\n  height: 42%;\n  display: flex;\n  flex-direction: column;\n  justify-content: flex-start;\n  align-items: flex-start;\n}\n\n.left-bar__outputs {\n  border-bottom: 1px solid black;\n}\n\n.left-bar__title-area {\n  background-color: rgb(131, 191, 131);\n  width: 100%;\n}\n\n/* Grey background area around the product selection */\n.left-bar__product-wrapper {\n    width: 100%;\n    background-color: #f0f0f0; /* Light grey background */\n    padding: 10px 0; /* Vertical padding to make it stand out */\n    display: flex;\n    justify-content: center; /* Optional: centers the dropdown */\n}\n\n.left-bar__product-area {\n    width: 90%; /* Optional: makes the select not fully stretched if you want some margin */\n}\n\n\n.left-bar__season-area {\n  border: 1px solid black;\n  border-left: 0px;\n  border-right: 0rem;\n  background-color: white;\n  width: 100%;\n}\n\n.left-bar__title {\n  margin-left: 1rem;\n}\n\n.left-bar__subtitle {\n  margin-left: 1rem;\n}\n\n.left-bar__subtitle {\n  margin-left: 1rem;\n  margin-top: 0.5rem;\n  margin-bottom: 0.5rem;\n}\n\n.left-bar__text {\n  font-size: 16px;\n  color: black;\n  margin-left: 1rem;\n}\n\n.left-bar__options-area {\n  display: flex;\n  flex-direction: column;\n  margin-top: 0.5rem;\n}\n\n.left-bar__temperature-select {\n  margin-top: 0.5rem;\n  margin-left: 1rem;\n}\n\n.left-bar__temperature-select select {\n  padding: 0.3rem;\n  /* Increases the padding for a larger clickable area */\n  border-radius: 4px;\n  /* Optional: rounded corners */\n}\n\n.left-bar__radio-options-area {\n  padding-top: 1rem;\n}\n\n.left-bar__temperature-select .dropdown-row {\n  display: flex;\n  justify-content: space-between;\n  /* Spread label and dropdown */\n  align-items: center;\n  /* Align items vertically */\n  margin-bottom: 1rem;\n  /* Add spacing between rows */\n}\n\n.left-bar__temperature-select label {\n  flex: 1;\n  /* Allow label to take up remaining space */\n  text-align: left;\n  /* Keep label text aligned to the left */\n  margin-right: 2rem;\n  /* Increase spacing between label and dropdown */\n}\n\n.left-bar__temperature-select select {\n  flex: 0;\n  /* Keep dropdown size fixed */\n  width: auto;\n  /* Let dropdown size itself naturally */\n  margin-left: auto;\n  /* Push dropdowns to the far right */\n}\n\n/* Select s veľkou šipkou (iba pre produkt a veličinu) */\n.left-bar__dropdown--large-arrow {\n    width: 100%;\n    font-size: 1rem;\n    padding: 8px 40px 8px 10px;\n    border: 1px solid black;\n    border-radius: 4px;\n    cursor: pointer;\n    background-color: white;\n\n    /* Vlastná veľká šipka */\n    background-image: url(\"data:image/svg+xml;utf8,<svg fill='black' height='24' viewBox='0 0 24 24' width='24' xmlns='http://www.w3.org/2000/svg'><path d='M7 10l5 5 5-5z'/></svg>\");\n    background-repeat: no-repeat;\n    background-position: right 5px center;\n    background-size: 30px 30px; /* Jemne väčšia šipka (nebude presahovať) */\n    appearance: none;\n    -moz-appearance: none;\n    -webkit-appearance: none;\n}\n\n/* Selecty so štandardnou šipkou (pre roky a zvyšné nastavenia) */\n.left-bar__dropdown {\n    width: auto;\n    font-size: 1rem;\n    padding: 0.3rem;\n    border: 1px solid black;\n    border-radius: 4px;\n    cursor: pointer;\n    background-color: white;\n}\n\n.velicina-option {\n  display: flex;\n  align-items: center;\n  margin-bottom: 0.5rem;\n}\n\n.velicina-option label {\n  margin-right: 0.5rem;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
